const imgSrcHelper = (src, variant) => {
  if (typeof src === 'object' && (src.name.includes('.svg') || src.name.includes('.gif'))) return src.urls.original;
  if (typeof src === 'string') return src;
  if (typeof src === 'object') return src.urls[variant];

  return null;
};

export default imgSrcHelper;
